import React, { act } from "react";
import { Skill, SkillTree, getAvailablePointsAtLevel, getMaxSkillLevel, getRequiredLevelForRow, getRequiredPointsForRow, getUsedSkillPoints } from "./SkillData";
import { SkillLevels } from "./SkillSimulator";

import "./SkillPreviewPane.scss"
import { translateRequirement, translateStat } from "./Translations";
import { clamp } from "./Util";

export interface SkillPreviewPaneProps {
    skills: Skill[];
    skillTree: SkillTree;
    selectedSkill: number;
    levels: SkillLevels;
    lvl: number;
    onLevelChange?: (id: number, lvl: number) => void;
    onMasteryBtnClicked?: () => void;
}

export class SkillPreviewPane extends React.Component<SkillPreviewPaneProps> {
    getActualReqs(skill: Skill) {
        const actualReqs: Record<string, string> = {};
        for (const req in skill.reqs) {
            if (req != "reqp")
                actualReqs[req] = skill.reqs[req];
        }
        return actualReqs;
    }
    shouldRenderReqs(skill: Skill) {
        return Object.keys(this.getActualReqs(skill)).length > 0;
    }
    renderSkillRequirements(skill: Skill) {
        const actualReqs = this.getActualReqs(skill);
        if (Object.keys(actualReqs).length == 0) {
            return <div className="skill-no-requirements">Brak</div>
        } else {
            const list: React.ReactNode[] = [];
            for (const req in actualReqs) {
                list.push(<div className="skill-requirement" key={req} dangerouslySetInnerHTML={{__html: translateRequirement(req, skill.reqs[req])}} />);
            }
            return <div className="skill-requirement-list">{list}</div>
        }
    }
    renderSkillEffects(skill: Skill) {
        const list: React.ReactNode[] = [];
        for (const stat in skill.stats) {
            const spl = skill.stats[stat].split(",");
            const indexFromSkillLevel = Math.max(0, (this.props.levels[skill.id] ?? 0) - 1);
            const currentValue = spl[Math.min(indexFromSkillLevel, spl.length - 1)];
            list.push(<div className="skill-effect extern-content" key={stat} dangerouslySetInnerHTML={{__html: translateStat(stat, currentValue, this.props.lvl)}} />);
        }
        return <div className="skill-effect-list">{list}</div>
    }
    renderSkillDetails(disabled: boolean) {
        const selectedSkill = this.props.skills.find(s => s.id == this.props.selectedSkill);
        if (selectedSkill) {
            const maxSkillLevel = getMaxSkillLevel(selectedSkill);
            const currentSkillLevel = this.props.levels[selectedSkill.id] ?? 0;
            const isActive = currentSkillLevel > 0;
            return <div className="skill-data">
                <div className="skill-name">{selectedSkill.name}</div>
                <div className="skill-level">
                    <div className="skill-level-text">Poziom umiejętności:</div>
                    <div className="skill-level-slider-wrapper">
                        <input disabled={disabled} min={0} max={10} value={currentSkillLevel} onChange={e => {
                            const newVal = Number(e.target.value);
                            if (this.props.onLevelChange) this.props.onLevelChange(selectedSkill.id, newVal);
                        }} onWheel={e => {
                            const newVal = clamp(0, currentSkillLevel + -Math.sign(e.deltaY + e.deltaX), maxSkillLevel);
                            if (this.props.onLevelChange) this.props.onLevelChange(selectedSkill.id, newVal);
                        }} type="range"></input>
                        <strong>{currentSkillLevel}/{maxSkillLevel}</strong>
                    </div>
                </div>
                <div className="skill-description">{selectedSkill.desc.split("#")[0]}</div>
                {this.shouldRenderReqs(selectedSkill) ?
                <div className="skill-requirements">
                    <div className="skill-requirements-title">Wymagania</div>
                    {this.renderSkillRequirements(selectedSkill)}
                </div> : ""}
                <div className={`skill-effects${isActive ? "" : " disabled"}`}>
                    <div className="skill-effects-title">Działanie umiejętności</div>
                    {this.renderSkillEffects(selectedSkill)}
                </div>
            </div>
        } else {
            return <div className="skill-not-selected">
                Po wybraniu umiejętności, w tym miejscu pokazane będą jej parametry.
            </div>
        }
    }
    render(): React.ReactNode {
        const usedPoints = getUsedSkillPoints(this.props.levels);
        const totalPoints = getAvailablePointsAtLevel(this.props.lvl);
        const selectedRow = this.props.skillTree.findIndex(row => row.includes(this.props.selectedSkill));
        const disabled = usedPoints < getRequiredPointsForRow(selectedRow);
        return <div className="skill-simulator-preview-pane">
            <div className="remaining-points">Wykorzystane punkty: {usedPoints} / {totalPoints}</div>
            {this.renderSkillDetails(disabled)}
            <div onClick={this.props.onMasteryBtnClicked} className="mastery-btn">Edytuj mistrzostwo walk</div>
        </div>
    }
}
